import React from 'react';
import { connect } from 'react-redux';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, InputGroupAddon, Input, InputGroupText, InputGroup, Col, Row } from 'reactstrap';
import { languageActions } from '../../store/actions/system/language/language.action';
import { formActions } from '../../store/actions/cms/form/form.action';
import './LanguageToggler.css'
import { tempLangConverter } from '../../helpers/lanugageHelper';

class LanguageToggler extends React.Component {
    state = {
        isOpen: false,
        codes: null,
        display: false
    }
    componentDidMount() {
        const { form, dispatch } = this.props;
        dispatch(languageActions.getAllCodesByEvent(form.eventId));
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.language !== this.props.language && this.props.language !== undefined) {
            const { eventCodes } = this.props.language;
            if (eventCodes !== undefined && eventCodes.length > 1) {
                this.setState({ codes: eventCodes, display: true });
            }

        }
    }
    toggleLanguage = (code) => {
        const { dispatch, event, form } = this.props;
        const formLangChanged = { ...form, languageCode: code };
        dispatch(formActions.softUpdate(Object.assign({}, formLangChanged)));
    }
    toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }
    render() {
        const { codes, display } = this.state;
        const { form } = this.props
        return (
            <React.Fragment>
                {display && <ButtonDropdown className="lang-toggler" style={{ backgroundColor: 'transparent', border: '0px' }} isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                    <DropdownToggle caret>
                    <i className={`flag-icon flag-icon-${tempLangConverter(form.languageCode)} `} />

                    </DropdownToggle>
                    <DropdownMenu style={{ backgroundColor: 'tranparent' }}>
                        {codes ? codes.map(c => {
                            return <DropdownItem s
                                tyle={form && form.eventLanguage === c ? { backgroundColor: '#2bafe257' } : null}
                                onClick={() => this.toggleLanguage(c)} key={c}>
                                <Row>
                                    <Col>
                                        <i className={`flag-icon flag-icon-${tempLangConverter(c)} `} />
                                    </Col>
                                  {/*   <Col style={{ paddingTop: '10px' }}>
                                        <div>{c}</div>
                                    </Col> */}
                                </Row>
                            </DropdownItem>
                        }) : <DropdownItem />}
                    </DropdownMenu>
                </ButtonDropdown >}
            </React.Fragment>

        )
    }
}


function mapStateToProps(state) {
    return {
        language: state.language,
        form: state.form,
        event: state.event,
    };
}

export default connect(mapStateToProps)(LanguageToggler);
